module.exports = __webpack_public_path__ + "img/871.c406e20c.png";